{
  "Language.SelectorLabel": "Cambiar idioma",
  "Language.FollowMicrosoft365": "Usar mi idioma de Microsoft 365",
  "Language.SaveFailed": "No se pudo guardar tu elección de idioma. Se aplica en este navegador hasta tu próxima visita.",
  "Header.SignOut": "Cerrar sesión",
  "Workspace.Brand": "Colaboración con proveedores de Edinshall",
  "Workspace.Title": "Espacio de calidad de proveedores"
}
